import { IconButton } from 'component/Button'
import { Modal } from 'component/Modal'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Buttons } from 'page/catalog/ItemPreview/Buttons'
import { Desc } from 'page/catalog/ItemPreview/Desc'
import { ItemDetails } from 'page/catalog/ItemPreview/ItemDetails'
import { ItemTitle } from 'page/catalog/ItemPreview/ItemTitle'
import { MainImage } from 'page/catalog/ItemPreview/MainImage'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import css from './ItemPreviewDesktop.module.scss'

export const ItemPreviewDesktop = observer(() => {
  const demo = useDemo()
  const { descriptions } = demo.product.details ?? {}
  const { item } = itemPreview.it
  const { description } = item
  const desc = descriptions && description

  const onClose = useLatestCallback(() => {
    itemPreview.close()
  })

  useBodyScrollLock(true)

  return (
    <Modal
      className={css.modal}
      open={itemPreview.present}
      onCancel={onClose}
      closeButton={false}
    >
      <Space top>
        <MainImage />
        <Vertical gap={20} pad={32} width={400} tall>
          <ItemTitle />
          <ItemDetails />
          {desc && (
            <Vertical gap={4} spring>
              <Typo size={13} upper secondary>
                {i18n('demo.Description')}
              </Typo>
              <Vertical flex="1 1 0">
                <Desc />
              </Vertical>
            </Vertical>
          )}
          {!desc && <Vertical spring />}
          <Buttons />
        </Vertical>
      </Space>
      <Space pin={[8, 8, null, null]}>
        <IconButton large action={onClose}>
          <Icon size={20} name="close" />
        </IconButton>
      </Space>
    </Modal>
  )
})
